import React, { useState } from 'react';
import styles from './nav-header.module.css';

const NavHeader = () => {
    const [isActive, setIsActive] = useState(false);

    const toggleNavbar = () => {
        setIsActive(!isActive);
    };

    return (
        <nav className={`${styles.navbar} ${isActive ? styles['navbar-active'] : ''}`}>
            <div className={styles['navbar-logo']}>UII</div>
            <ul className={styles['navbar-links']}>
                <li><a href="/recruiter/home">Home</a></li>
                <li><a href="/recruiter/live-posted-jobs">Live Posted Jobs</a></li>
                <li><a href="/recruiter/all-my-jobs">All My Jobs</a></li>
                <li><a href="/recruiter/messages">Messages</a></li>
                <li><a href="/recruiter/profile">My Profile</a></li>
                <li><a href="/recruiter/company-profile">Company Profile</a></li>
                <li><a href="/recruiter/settings">Settings</a></li>
                <li><a href="/recruiter/logout">Logout</a></li>
            </ul>
            <div className={styles['navbar-toggle']} onClick={toggleNavbar}>
                <span className={styles.bar}></span>
                <span className={styles.bar}></span>
                <span className={styles.bar}></span>
            </div>
        </nav>
    );
};

export default NavHeader;
